<div class="grid-x">
    <label [for]="controlId" style="width: 100%;">
        <span>Default Value</span>
        <input [id]="controlId" [name]="controlName" type="text" [(ngModel)]="componentData.defaultValue">
    </label>
</div>
